import SelectRosterTabs from "../components/SelectRosterTabs";

const SelectRoster = () => {
  return (
    <div className="container">
      <SelectRosterTabs />
    </div>
  );
};

export default SelectRoster;
